module.exports = __webpack_public_path__ + "img/speech-balloon.b6d5ecc9.svg";